import React, {Component} from 'react'

export default class TextField extends Component {
    state = {
        value: ''
    }

    componentDidMount() {
        this.setState({
            value: this.props.field.value
        })
    }

    onChange = value => {
        this.setState({
            value
        }, () => {
            this.props.onChange(value)
        })
    }

    render() {
        if (this.props.field.readonly) {
            return this.props.field.value;
        }

        return (
            <input className={this.props.customClassName || ""} type="text" name={this.props.field.slug}
                   value={this.state.value || ''} onChange={e => this.onChange(e.target.value)}/>
        )
    }
}